<template>
    <div ref="lazyComponent">
        <slot v-if="isVisible" />
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';

const lazyComponent = ref<HTMLElement | null>(null);
const isVisible = ref(false);

onMounted(() => {
    try {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    isVisible.value = true;
                    observer.disconnect();
                }
            });
        });
        if (lazyComponent.value) {
            observer.observe(lazyComponent.value);
        }
    } catch (error) {
        console.error(error);
        isVisible.value = true;
    }
});
</script>
